export const EMP_ANNUAL_COMPENSATION_DETAILS = 'empAnnualCompensationDetails';
export const VALIDATE_ANNUAL_COMPENSATION_DETAILS = 'validateEmpAnnualCompensationDetails';
export const EMP_ADVANCE_SALARY_DETAILS = 'empAdvanceCompensationDetails';